module.exports = __webpack_public_path__ + "static/media/google-play-icon.647fe619.svg";